import React from 'react';
import PropTypes from 'prop-types';
import 'react-dom';
import './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import styled from 'styled-components';
import './withTooltip-92e0dfed.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import { I as Icon } from './index-28a062d6-3659b895.js';
import { T as Text } from './text-5e5c8ea1.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import { B as Box } from './box-e581bc98.js';

var ScreenWrapperStyle = function ScreenWrapperStyle(props) {
  return {
    backgroundColor: props.theme.colors.grey.soft,
    width: "100%",
    height: "100%",
    margin: "auto",
    justifyContent: "center",
    alignItems: "center",
    padding: "0px"
  };
};
var ScreenWrapper = styled(Box)(ScreenWrapperStyle);
var MessageContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
});
var IconBox = styled(Icon)({
  minWidth: "100px",
  height: "auto",
  margin: "0px auto 32px auto"
});
var BoxStyle = function BoxStyle(props) {
  return {
    height: "80px",
    width: "80px",
    padding: 0,
    borderRadius: "50%",
    overflow: "hidden",
    backgroundColor: props.theme.colors.grey.neon,
    display: "flex"
  };
};
var DefaultIcon = styled(Box)(BoxStyle);

var TextBox = function TextBox(_ref) {
  var testid = _ref.testid,
    variant = _ref.variant,
    lineHeight = _ref.lineHeight,
    text = _ref.text;
  return /*#__PURE__*/React.createElement(Text, {
    "data-testid": testid,
    variant: variant,
    color: "black.haptik",
    textAlign: "center",
    lineHeight: lineHeight
  }, text);
};
var EmptyState = function EmptyState(_ref2) {
  var title = _ref2.title,
    subtitle = _ref2.subtitle,
    icon = _ref2.icon;
  return /*#__PURE__*/React.createElement(ScreenWrapper, null, /*#__PURE__*/React.createElement(MessageContainer, null, icon ? /*#__PURE__*/React.createElement(IconBox, {
    src: icon
  }) : /*#__PURE__*/React.createElement(DefaultIcon, null), /*#__PURE__*/React.createElement(Box, {
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(TextBox, {
    testid: "title",
    variant: "display-2.semi-bold",
    lineHeight: "29px",
    text: title
  })), subtitle && /*#__PURE__*/React.createElement(Box, {
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(TextBox, {
    "data-testid": "subtitle",
    variant: "body.lg",
    lineHeight: "19px",
    text: subtitle
  }))));
};
TextBox.propTypes = {
  testid: PropTypes.string,
  variant: PropTypes.string,
  lineHeight: PropTypes.string,
  text: PropTypes.string
};
TextBox.defaultProps = {
  testid: "",
  variant: "body.lg",
  lineHeight: "19px",
  text: ""
};
EmptyState.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.element
};
EmptyState.defaultProps = {
  title: "",
  subtitle: "",
  icon: null
};
EmptyState.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EmptyState",
  "props": {
    "title": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "subtitle": {
      "defaultValue": {
        "value": "\"\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "icon": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "element"
      },
      "required": false,
      "description": ""
    }
  }
};

export default EmptyState;
